var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inter-hospital" }, [
    _c(
      "div",
      { staticClass: "hospital-content padding-main mobile-padding" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-col",
              {
                staticClass: "hospital-desc",
                attrs: { xs: 24, sm: 24, md: 8 },
              },
              [
                _c("div", { staticClass: "hospital-title" }, [
                  _vm._v(_vm._s(_vm.$t("interHospital.yyInterHospital"))),
                ]),
                _c("div", { staticClass: "hospital-tip" }, [
                  _vm._v(_vm._s(_vm.$t("interHospital.yyInterHospitalTip"))),
                ]),
                _c(
                  "div",
                  { staticClass: "hospital-btn hidden-sm-and-down" },
                  _vm._l(_vm.btnList, function (item, index) {
                    return _c(
                      "el-button",
                      {
                        key: index,
                        staticClass: "btn-item",
                        attrs: {
                          type: index === 4 ? "info" : "primary",
                          size: "medium",
                          round: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.jumpPage(item)
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(item.name) + "\n            "),
                        _c("i", { staticClass: "el-icon-arrow-right" }),
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  { staticClass: "qr-code hidden-sm-and-down" },
                  [
                    _c("el-image", {
                      staticStyle: { width: "117px", height: "117px" },
                      attrs: { src: "/img/yy_hospital_mini.jpg", fit: "cover" },
                    }),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("interHospital.yyInterHospital"))),
                    ]),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-col",
              {
                staticStyle: { "text-align": "right" },
                attrs: { xs: 24, sm: 24, md: 16 },
              },
              [
                _c(
                  "div",
                  { staticClass: "image-flex" },
                  [
                    _c("el-image", {
                      staticClass: "hospital-image",
                      attrs: { src: "/img/inter_hospital.png", fit: "cover" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hospital-scheme padding-main-new mobile-padding" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("interHospital.interHospitalSolution"))),
        ]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.schemeList, function (item, index) {
            return _c("div", { key: index, staticClass: "scheme-item" }, [
              _c(
                "div",
                { staticClass: "item-image" },
                [_c("el-image", { attrs: { src: item.icon, fit: "cover" } })],
                1
              ),
              _c("div", { staticClass: "item-title" }, [
                _vm._v(_vm._s(item.title)),
              ]),
              _c("div", { staticClass: "item-tip" }, [
                _vm._v(_vm._s(item.tip)),
              ]),
            ])
          }),
          0
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "hospital-recipe padding-main-new mobile-padding" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("interHospital.recipeForStore"))),
        ]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.provideRecipeList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "recipe-item",
                style: { backgroundImage: "url(" + item.backgroundImg + ")" },
              },
              [
                _c(
                  "div",
                  { staticClass: "item-image" },
                  [_c("el-image", { attrs: { src: item.icon, fit: "cover" } })],
                  1
                ),
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c("div", { staticClass: "item-tip" }, [
                  _vm._v(_vm._s(item.tip)),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "hospital-construct padding-main-new mobile-padding" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("interHospital.constructForHospital"))),
        ]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.constructList, function (item, index) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "construct-item" }, [
                _c(
                  "div",
                  { staticClass: "item-image" },
                  [_c("el-image", { attrs: { src: item.icon, fit: "cover" } })],
                  1
                ),
                _c("div", { staticClass: "item-info" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _c("div", { staticClass: "item-tip" }, [
                    _vm._v(_vm._s(item.tip)),
                  ]),
                ]),
              ]),
              index !== _vm.constructList.length - 1
                ? _c(
                    "div",
                    { staticClass: "construct-icon hidden-md-and-up" },
                    [_c("i", { staticClass: "el-icon-arrow-down" })]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "hospital-flow padding-main-new mobile-padding" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("interHospital.recipeFlowPlatform"))),
        ]),
        _c("div", { staticClass: "title1" }, [
          _vm._v(_vm._s(_vm.$t("interHospital.recipeFlowPlatformTip2"))),
        ]),
        _c("el-image", {
          attrs: { src: "/svg/recipe_flow.svg", fit: "cover" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }